<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <label class="btn btn-outline-primary active type_button">
                            <input type="radio" name="options" id="option1" autocomplete="off" checked> {{transEdit('email')}}
                        </label>
                        <label class="btn btn-outline-primary type_button">
                            <input type="radio" name="options" id="option2" autocomplete="off"> {{transEdit('sms')}}
                        </label>
                    </div>
                </div>
                <div class="form-group">
                    <label for="recipients[]">{{transEdit('receiver')}}</label>
                    <input type="text" class="form-control" id="recipients[]" name="recipients[]" placeholder="">
                </div>
                <div class="form-group">
                    <label for="recipients[]">{{transEdit('subject')}}</label>
                    <input type="text" class="form-control" id="recipients[]" name="recipients[]" placeholder="">
                </div>
                <div class="form-group">
                    <label for="message">>{{transEdit('message')}}</label>
                    <textarea class="form-control" id="message" name="message" rows="10"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">><i class="fa fa-paper-plane"></i> {{transEdit('send')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "communication",
        props: ['user_id'],
        data() {
            return {
            }
        },
        methods: {
        },
    }
</script>

<style scoped>
.type_button {
    width: 70px;
}
</style>